import React, { useState } from "react";
import { toast } from "react-toastify";
import {
  FiCopy,
  handleCopy,
} from "@/components/common/commonFunction/handleCopy";

export default function NumberToRoman() {
  const { stringify } = require("roman-numerals-convert");
  const [number, setNumber] = useState(null);
  const [value, setvalue] = useState(null);
  const [roman, setRoman] = useState("");
  const [err, setErr] = useState(false);
  const [copy, setCopy] = useState(false);
  const [errors, setErrors] = useState("");

  const handleOnChange = (e) => {
    setErr(false);
    setCopy(false);
    setvalue(e.target.value);
    setRoman("");
    if (!e.target.value) return;
    try {
      let value = parseInt(e.target.value);
      setNumber(stringify(value));
    } catch (error) {
      setErr(error);
    }
    if (err) {
      toast.error(err.message);
    }
    setErrors("");
  };
  const handleOnSubmit = () => {
    if (validateForm()) {
      setRoman(number);
    }
  };

  const validateForm = () => {
    let formIsValid = true;

    if (!value) {
      setErrors("* Please enter number");

      formIsValid = false;
    }
    return formIsValid;
  };

  return (
    <div className="aritmetic-two-col-grid">
      <div className="commom-box-new">
        <div className="input-new">
          <input
            type="number"
            placeholder="Enter A  Number Between 0-3999"
            value={value}
            onChange={handleOnChange}
            className={errors && "error-input"}
          ></input>
          <span className="text-sm text-red-700">{errors}</span>
        </div>
      </div>
      <div className="button lowercase-center-alignment">
        <button disabled={number === 0} onClick={handleOnSubmit}>
          Convert
        </button>
      </div>
      {roman && (
        <div className="commom-box-new">
          <div className="copy-textarea-icon-alignment">
            <FiCopy onClick={() => handleCopy(roman)} />
            {copy && (
              <div>
                <span>Copied</span>
              </div>
            )}
          </div>
          <div className="input-new">
            <input
              type="text"
              value={roman}
              disabled
              className="text-black"
            ></input>
          </div>
        </div>
      )}
    </div>
  );
}
